/**
 * Whether the reader asked the system for reduced motion — for the animations
 * framer-motion's <MotionConfig reducedMotion="user"> does not reach (a number
 * counting up on a timer, text typed out character by character). Follows the
 * setting live.
 */
import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

// A runtime without matchMedia (server rendering, jsdom) has no such setting.
const media = (): MediaQueryList | null =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(QUERY)
    : null;

function subscribe(onChange: () => void): () => void {
  const mql = media();
  mql?.addEventListener('change', onChange);
  return () => mql?.removeEventListener('change', onChange);
}

export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => media()?.matches ?? false,
    () => false
  );
}
